<template>
  <v-container fluid>
    
<!--    <div class="d-flex flex-column" style="height: calc(100vh - 88px - 36px);">-->
      <div v-if="isLoading" class="d-flex justify-center my-2">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </div>

<!--      <v-container v-if="!isIntersecting" class="text-center mb-2">
        <strong>{{ $t('pages.privacy.scrollDown') }}</strong>
      </v-container>-->
      <v-container
          v-if="$i18n.locale === 'en'"
          class="my-2"
      >
<!--        <v-card tile flat class="pa-6">-->
          <h1>Privacy policy</h1>
          <br/>
          <br/>

          <p>We attach great importance to the security and confidentiality of your personal data that we collect and use. This privacy policy informs you about the processing of your personal data and was last updated on April 22, 2022.</p>
          <br/>

          <p>
            <strong>We also use cookies on our website. For more information about this we kindly refer you to our cookie policy</strong>
            <br/>
            <strong><a href="https://movetohappiness.com/cookies/" target="_blank">https://movetohappiness.com/cookies/</a></strong>
          </p>
          <br/>

          <h1>1.WHEN DOES THIS PRIVACY POLICY APPLY?</h1>
          <p>1.1. We collect and use your personal data when you:</p>
          <br/>

          <ul>
            <li>use our website (www.movetohappiness.com);</li>
            <li>use our social media (Facebook, Instagram or YouTube);</li>
            <li>use our services (<a href="https://watch.movetohappiness.com" target="_blank">https://watch.movetohappiness.com</a> or <a href="https://go.movetohappiness.com/" target="_blank">https://go.movetohappiness.com/</a>) you register for or participate in our events;</li>
            <span>and</span>
            <li>communicate with us via email, telephone or another digital communication channel.</li>
          </ul>
          <br/>

          <p>1.2. This privacy policy is subject to change as provided in article 8.</p>
          <br/>

          <h1>2. WHO ARE WE?</h1>
          <p>2.1. In this privacy policy, “we” refers to Move To Happiness bv:</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Name:</td>
                  <td>Move To Happiness Hub bv</td>
                </tr>
                <tr>
                  <td>Adress:</td>
                  <td>Statiestraat 3, bus B, 2560 Nijlen</td>
                </tr>
                <tr>
                  <td>Enterprise Number:</td>
                  <td>0437.586.004</td>
                </tr>
                <tr>
                  <td>E-mail:</td>
                  <td>rose@movetohappiness.com</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>2.2. We are responsible for collecting and using your personal data in the manner explained in this privacy policy. If you have any questions about this, please contact us by email (info@movetohappiness.com).</p>

          <p>2.3. In certain circumstances, third parties may (also) be responsible for the processing of your personal data, for example, if you click on a link and thereby leave our website or if you use our social media and have a social media account yourself. We have no influence on the data that social media providers collect about you. If you use our services through your employer, your employer also acts

            as the controller for the processing of your personal data. In these cases, we recommend that you consult the privacy policies of these third parties.</p>
          <br/>

          <h1>3. WHICH PERSONAL DATA DO WE PROCESS AND WHY?</h1>

          <p>We only process your personal data for a specific purpose and to the extent permitted by law. We further explain below in which cases we collect and use your personal data. If we do not receive your personal data directly from you, we will also inform you about this below.</p>

          <p>3.1. WHEN YOU USE OUR WEBSITE</p>

          <p>3.1.1. When you use our website, we collect and use the following personal data.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Technical information (e.g. server log files) about your visit and the device you use. We cannot identify you based on this information, but third parties may (e.g. your internet service provider)</td>
                  <td>To ensure the most trouble-free operation of our website and to detect and prevent malware, illegal content and behavior, and other forms of possible misuse.</td>
                  <td>Our legitimate interest in keeping our online presence secure.</td>
                </tr>
                <tr>
                  <td>Your e-mail address.</td>
                  <td>To send you our newsletter or other electronic communication.</td>
                  <td>Your consent, unless you are an existing customer of ours who we want to keep informed about our products or services. You can always withdraw your consent as stipulated in article 7.</td>
                </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.2. WHEN YOU USE OUR SOCIAL MEDIA</p>

          <p>3.2.1. When you use our social media (Facebook, Instagram, YouTube), we collect and use the following personal data.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>When you send messages to us via social media, we collect your identity and contact details, the content of your message, and the technical details of your message (e.g. date and time).</td>
                  <td>To enable messages between you and us via social media. These messages are not public. However, if you post a comment or like or post other data (e.g. photos) on our public social media, then this data is public.</td>
                  <td>Our legitimate interest in being able to respond to requests, questions, or comments or to proactively contact you with questions of any kind.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.3. WHEN YOU USE OUR SERVICES OR APP</p>

          <p>3.3.1. WHEN YOU USE OUR SERVICES OR APP</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identity and contact details, and personal characteristics (e.g. gender and date of birth), which you provide to us when you register and afterward.</td>
                  <td>To create and manage your account so that you can use our services or app.</td>
                  <td>Our agreement with you through your acceptance of the Terms of Use. <a href="https://movetohappiness/terms-of-use" target="_blank">https://movetohappiness/terms-of-use</a></td>
                </tr>
                <tr>
                  <td>Information about your device with which you use our app and data such as your IP address, your browser type, your operating system, and your Internet Service Provider (ISP).</td>
                  <td>To improve the content of and the general user experience of our app.</td>
                  <td>Our legitimate interest in improving our services, making sure our app works properly, and providing our users with the most disruption-free experience possible.</td>
                </tr>
                <tr>
                  <td>Information about your use of our app such as viewing activity, referring/exit pages, date and timestamps, and related metadata. In addition, we also receive aggregated demographic data of our total user base from Apple and Google.</td>
                  <td>To improve the content of and the general user experience of our app.</td>
                  <td>Our legitimate interest in providing our users with an interesting experience.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.4. WHEN YOU REGISTER FOR OR PARTICIPATE IN OUR EVENTS</p>

          <p>3.4.1. When you register for or participate in our events, we collect and use the following personal data.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identity and contact details that you provide to us in the context of, if applicable, your registration and participation in our events (e.g. name, email address, or company you work for).</td>
                  <td>To process your registration and prepare, organize and secure our events</td>
                  <td>Our agreement with you through your acceptance of the applicable terms.</td>
                </tr>
                <tr>
                  <td>Photo(s) taken during an event in which you are recognizable.</td>
                  <td>To capture and share atmospheric images of the event (e.g. on our website and our social media).</td>
                  <td>Your consent. You can always withdraw your consent as stipulated in article 7.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.5. WHEN YOU COMMUNICATE WITH US</p>

          <p>3.5.1. When you communicate with us via social media, telephone, email, or any other digital communication channel, we collect and use the following personal data.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identity and contact details you provide to us, the content of your communication, the technical details of the communication itself (e.g. date and time) and, if applicable, the device you are using.</td>
                  <td>To enable communication between you and us (e.g. when you contact us via social media, telephone, or email).</td>
                  <td>Our legitimate interest in being able to respond to requests, questions, or comments or to proactively contact you with questions of any kind.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.6. IN ALL OF THE ABOVE CASES</p>

          <p>3.6.1. However, for all personal data that we collect in the above circumstances, we would like to make it clear that we will also process your personal data in the following cases.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Which personal data?
                  </th>
                  <th class="text-left">
                    Why?
                  </th>
                  <th class="text-left">
                    Legal basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>The personal data above.</td>
                  <td>To comply with our legal obligations or to comply with any reasonable request from competent police forces, judicial authorities, government agencies, or bodies, including competent data protection authorities.</td>
                  <td>Our legal obligation.</td>
                </tr>
                <tr>
                  <td>The personal data above.</td>
                  <td>To prevent, detect and combat fraud or other illegal or unauthorized activities.</td>
                  <td>Our legal obligation.</td>
                </tr>
                <tr>
                  <td>The personal data above.</td>
                  <td>To defend ourselves in legal proceedings.</td>
                  <td>Our legitimate interest in using your personal data in these procedures.</td>
                </tr>
                <tr>
                  <td>The personal data above.</td>
                  <td>To inform a third party in the context of a possible merger with, acquisition from/by or demerger by that third party, even if that third party is located outside the EU.</td>
                  <td>Our legitimate interest in being able to engage in business transactions.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <h1>4. WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</h1>

          <p>4.1. We do not share your personal data with anyone other than the people who work for us, as well as with the suppliers who help us with the processing of your personal data or your employer if applicable. Anyone who has access to your personal data will always be bound by strict legal or contractual obligations to keep your personal data safe and confidential.</p>

          <p>4.2. Your personal data may be sent by us outside the European Economic Area (EEA) for the purposes stated above. If a transfer takes place, we will take adequate safeguards to protect your personal data upon transfer (e.g. by entering into a contract based on standard data protection clauses approved by the European Commission).</p>
          <br/>

          <h1>5. HOW LONG DO WE KEEP YOUR PERSONAL DATA?</h1>

          <p>5.1. Your personal data will only be processed for as long as necessary to achieve the purposes described above or, if we have asked you for your consent, until you withdraw your consent. In this article, we provide you with the information you need to assess how long we keep your personal data identifiable.</p>

          <p>5.2. In general, we will de-identify your personal data when it is no longer needed for the purposes described above or when the retention period, as explained in this article 5, has expired. However,

            we cannot delete your personal data if there is a legal or regulatory obligation or a court or administrative order that prevents us from deleting it.</p>

          <p>5.3. We keep all personal data that we collect via our website for as long as necessary to represent the legitimate interests referred to in article 3.1 or until you withdraw your consent. We store technical information such as our server log files for up to 1 year after your visit to our website, after which they are deleted or de-identified.</p>

          <p>5.4. We keep all personal data that we collect in the context of our services, whether or not via our mobile app, for as long as necessary to perform the agreement with you or to represent the legitimate interests referred to in article 3.3. We keep your data in connection with the management of your account and in the context of our services as long as you use our services. We will not retain technical information related to your use of our mobile app for more than 5 years after your last use of our app, after which it will be deleted or de-identified.</p>

          <p>5.5. We keep all personal data that we collect in connection with our events for as long as necessary to perform the agreement with you, to represent the legitimate interests mentioned in article 3.4, or until you withdraw your consent. If your photo has not been published, we will not keep your photo for longer than 2 years after the relevant event. If you wish to object to a published photo of you during an event, please let us know (see article 9).</p>

          <p>5.6. We keep all personal data that we collect through our interactions with you via social media, telephone, email or other digital communication channels for as long as necessary to communicate with you, but also to keep a historical archive of our communication. This allows us to revert to previous communications if you come back to us with new questions, requests, comments, or other input.</p>
          <br/>

          <h1>6. HOW DO WE PROTECT YOUR PERSONAL DATA?</h1>

          <p>6.1. The security and confidentiality of the personal data we process are very important to us. That is why we have taken measures to ensure that all processed personal data is kept secure. These measures include technical and organizational measures to secure our infrastructure, systems, applications, and processes. We have also taken other measures, such as taking internal policies, limiting the processing to the personal data necessary for the achievement of the purposes, minimizing the processing of personal data, pseudonymizing personal data if possible, making backups of personal data, and periodically evaluating our security measures.</p>
          <br/>

          <h1>7. YOUR RIGHTS IN RELATION TO YOUR PERSONAL DAT</h1>

          <p>7.1. You have certain rights in relation to the processing of your personal data: the right of access, rectification, deletion, and portability of personal data, as well as the right to object to or restrict the processing of your personal data and to withdraw your consent. To exercise one of your rights, you can submit a written request to info@movetohappiness.com stating the right to which your request relates. If you are still not satisfied, you have the right to contact the qualified data protection authority, i.e. the Belgian Data Protection Authority.(<a href="www.dataprotectionauthority.be" target="_blank">www.dataprotectionauthority.be</a>).</p>
          <br/>

          <h1>8. CHANGES TO THIS PRIVACY POLICY</h1>

          <p>8.1. We may change this privacy policy at our own initiative and at any time. If material changes to this privacy policy may affect the processing of your personal data, we will communicate those changes to you in the manner in which we normally communicate with you (e.g. via e-mail or via a message on our website or via our mobile app).</p>

          <p>8.2. We invite you to review the latest version of this privacy policy on our website. Our privacy policy states the date when our privacy policy was last modified.</p>
          <br/>

          <h1>9. DO YOU HAVE ANY QUESTIONS?</h1>

          <p>9.1. If you have any questions about the processing of your personal data, please do not hesitate to contact our privacy manager. You can contact our privacy manager by e-mail: <a href="mailto:info@movetohappiness.com">info@movetohappiness.com</a>.</p>

<!--          <div
              v-intersect="onIntersect"
              class="py-12"
          ></div>-->
         
<!--        </v-card>-->
      </v-container>
    
      <v-container
          v-else
          class="my-2"
      >
<!--        <v-card tile flat class="pa-6">-->
          <h1>Privacy beleid</h1>
          <br/>
          <br/>

          <p>Wij hechten veel belang aan de veiligheid en vertrouwelijkheid van jouw persoonsgegevens die wij verzamelen en gebruiken. Dit privacybeleid informeert jou over de verwerking van jouw persoonsgegevens en werd laatst bijgewerkt op 15 maart 2022.</p>
          <br/>

          <p>
            <strong>Wij gebruiken ook cookies op onze website. Voor meer informatie hierover, verwijzen wij jou vriendelijk naar ons cookiebeleid.</strong>
            <br/>
            <strong><a href="https://movetohappiness.com/cookies/" target="_blank">https://movetohappiness.com/cookies/</a></strong>
          </p>
          <br/>

          <h1>1.Wanneer is dit privacybeleid van toepassing?</h1>
          <p>1.1. Wij verzamelen en gebruiken jouw persoonsgegevens wanneer je:</p>
          <br/>

          <ul>
            <li>onze website (www.movetohappiness.com) gebruikt;</li>
            <li>onze sociale media (Facebook, Instagram, LinkedIn of YouTube) gebruikt;</li>
            <li>onze diensten (<a href="https://watch.movetohappiness.com" target="_blank">https://watch.movetohappiness.com</a> of <a href="https://go.movetohappiness.com/" target="_blank">https://go.movetohappiness.com/</a>) je registreert voor of deelneemt aan onze evenementen;</li>
            <span>en</span>
            <li>met ons communiceert via email, telefoon of een ander digitaal communicatiekanaal.</li>
          </ul>
          <br/>

          <p>1.2. Dit privacybeleid kan gewijzigd worden zoals bepaald in artikel 8.</p>
          <br/>

          <h1>2. Wie zijn wij?</h1>
          <p>2.1. “Wij” verwijst in dit privacybeleid naar Move To Happiness bv:</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Naam:</td>
                  <td>Move To Happiness Hub bv</td>
                </tr>
                <tr>
                  <td>Adres:</td>
                  <td>Statiestraat 3, bus B, 2560 Nijlen</td>
                </tr>
                <tr>
                  <td>Ondernemingsnummer:</td>
                  <td>0437.586.004</td>
                </tr>
                <tr>
                  <td>E-mail:</td>
                  <td>rose@movetohappiness.com</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>2.2. Wij zijn verantwoordelijk voor het verzamelen en gebruiken van jouw persoonsgegevens op de wijze uitgelegd in dit privacybeleid. Als je vragen hebt hierover, contacteer ons dan per e-mail (rose@movetohappiness.com).</p>

          <p>2.3. In bepaalde omstandigheden kunnen derde partijen (ook) verantwoordelijk zijn voor de verwerking van jouw persoonsgegevens, bijvoorbeeld als je op een link klikt en daardoor onze website verlaat of als je gebruik maakt van onze sociale media en zelf een sociale media-account hebt. Wij hebben geen invloed op de gegevens die sociale media providers over jou verzamelen. Als je gebruik maakt van onze diensten via jouw werkgever, treedt jouw werkgever ook op als verantwoordelijke voor de verwerking van jouw persoonsgegevens. In deze gevallen raden wij aan om het privacybeleid van deze derde partijen te raadplegen.</p>
          <br/>

          <h1>3. Welke persoonsgegevens verwerken wij en waarom?</h1>

          <p>Wij verwerken jouw persoonsgegevens enkel voor een bepaald doel en voor zover toegelaten door de wet. Wij lichten hieronder verder toe in welke gevallen wij jouw persoonsgegevens verzamelen en gebruiken. Als wij jouw persoonsgegevens niet rechtstreeks van jou ontvangen, zullen wij jou ook hierover hieronder informeren.</p>

          <p>3.1. Wanneer je onze website gebruikt</p>

          <p>3.1.1. Wanneer je gebruik maakt van onze website, verzamelen en gebruiken wij de volgende persoonsgegevens.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Technische informatie (bv. serverlogbestanden) over jouw bezoek en het apparaat dat je gebruikt. Wij kunnen jou niet identificeren op basis van deze informatie, maar derde partijen misschien wel (bv. jouw internet service provider).</td>
                  <td>Om een zo storingsvrij mogelijke werking van onze website te waarborgen en om malware, illegale inhoud en gedrag en andere vormen van mogelijk misbruik op te sporen en te voorkomen.</td>
                  <td>Ons legitiem belang om onze online aanwezigheid veilig te houden.</td>
                </tr>
                <tr>
                  <td>Jouw e-mailadres.</td>
                  <td>Om jou onze nieuwsbrief of andere elektronische communicatie toe te sturen.</td>
                  <td>Jouw toestemming, tenzij je een bestaande klant van ons bent die wij op de hoogte willen houden van onze producten of diensten. Je kunt jouw toestemming steeds intrekken zoals bepaald in artikel 7.</td>
                </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.2. Wanneer je onze sociale media gebruikt</p>

          <p>3.2.1. Wanneer je gebruik maakt van onze sociale media (Facebook, Instagram, YouTube), verzamelen en gebruiken wij de volgende persoonsgegevens.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Als je berichten naar ons stuurt via sociale media, verzamelen wij jouw identiteits- en contactgegevens, de inhoud van jouw bericht en de technische details van jouw bericht (bv. datum en tijd).</td>
                  <td>Om berichten tussen jou en ons mogelijk te maken via sociale media. Deze berichten zijn niet openbaar. Als je echter een reactie of like plaatst of andere gegevens (bv. foto’s) op onze publieke sociale media plaatst, dan zijn deze gegevens openbaar.</td>
                  <td>Ons legitiem belang om te kunnen reageren op verzoeken, vragen of opmerkingen of om proactief contact met jou op te nemen voor vragen van welke aard dan ook.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.3. Wanneer je onze diensten of app gebruikt</p>

          <p>3.3.1. Wanneer je gebruik maakt van onze diensten of onze mobiele app, verzamelen en gebruiken wij de volgende persoonsgegevens.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identiteits- en contactgegevens, en persoonlijke kenmerken (bv. geslacht en geboortedatum), die je ons bij jouw registratie en daarna aan ons verstrekt.</td>
                  <td>Om jouw account aan te maken en te beheren zodat je onze diensten of app kunt gebruiken.</td>
                  <td>Onze overeenkomst met jou door jouw aanvaarding van de gebruiksvoorwaarden. <a href="https://movetohappiness/terms-of-use" target="_blank">https://movetohappiness/terms-of-use</a></td>
                </tr>
                <tr>
                  <td>Informatie over jouw apparaat waarmee je onze app gebruikt en gegevens zoals uw IP-adres, uw browsertype, uw besturingssysteem en uw Internet Service Provider (ISP),.</td>
                  <td>Om de inhoud van en de algemene gebruikservaring van onze app te verbeteren.</td>
                  <td>Ons legitiem belang om onze diensten te verbeteren, ervoor te zorgen dat onze app goed werkt en om onze gebruikers een zo storingsvrij mogelijke ervaring te kunnen bieden.</td>
                </tr>
                <tr>
                  <td>Informatie over jouw gebruik van onze app zoals kijkactiviteit, verwijzende/afsluitende pagina’s, datum en tijdstempels en verwante metadata. Daarnaast ontvangen we van Apple en Google ook gebundelde demografische gegevens van onze totale gebruikersgroep.</td>
                  <td>Om de inhoud van en de algemene gebruikservaring van onze app te verbeteren.</td>
                  <td>Ons legitiem belang om onze gebruikers een interessante ervaring te kunnen bieden.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.4. Wanneer je je registreert voor of deelneemt aan onze evenementen</p>

          <p>3.4.1. Wanneer je je registreert voor of deelneemt aan onze evenementen, verzamelen en gebruiken wij de volgende persoonsgegevens.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identiteits- en contactgegevens die je ons verstrekt in het kader van, indien van toepassing, jouw registratie en deelname aan onze evenementen (bv. naam, e-mailadres  of bedrijf waarvoor je werkt).</td>
                  <td>Om jouw registratie te verwerken en onze evenementen voor te bereiden, organiseren en veilig te laten verlopen.</td>
                  <td>Onze overeenkomst met jou door jouw aanvaarding van de toepasselijke voorwaarden.</td>
                </tr>
                <tr>
                  <td>Foto(‘s) genomen tijdens een evenement waarop je herkenbaar bent.</td>
                  <td>Om sfeerbeelden van het evenement vast te leggen en te delen (bv. op onze website en onze sociale media).</td>
                  <td>Jouw toestemming. Je kunt jouw toestemming steeds intrekken zoals bepaald in artikel 7.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.5. Wanneer je met ons communiceert</p>

          <p>3.5.1. Wanneer je met ons communiceert via sociale media, telefoon, email of een ander digitaal communicatiekanaal, verzamelen en gebruiken wij de volgende persoonsgegevens.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Identiteits- en contactgegevens die je ons verstrekt, de inhoud van jouw communicatie, de technische details van de communicatie zelf (bv. datum en tijd) en, indien van toepassing, het apparaat dat je gebruikt.</td>
                  <td>Om de communicatie tussen jou en ons mogelijk te maken (bv. wanneer je contact met ons opneemt via sociale media, telefoon of email).</td>
                  <td>Ons legitiem belang om te kunnen reageren op verzoeken, vragen of opmerkingen of om proactief contact met jou op te nemen voor vragen van welke aard dan ook.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <p>3.6. In alle bovenstaande gevallen</p>

          <p>3.6.1. Voor alle persoonsgegevens die wij in de bovengenoemde omstandigheden verzamelen, willen wij echter duidelijk maken dat wij jouw persoonsgegevens ook zullen verwerken in de volgende gevallen.</p>

          <v-card tile outlined>
            <v-simple-table class="rounded-0 transparent">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Welke persoonsgegevens?
                  </th>
                  <th class="text-left">
                    Waarom?
                  </th>
                  <th class="text-left">
                    Wettelijke basis?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Bovengenoemde persoonsgegevens.</td>
                  <td>Om onze wettelijke verplichtingen na te komen of te voldoen aan elk redelijk verzoek van bevoegde politiediensten, gerechtelijke autoriteiten, overheidsinstellingen of -organen, met inbegrip van bevoegde gegevensbeschermingsautoriteiten.</td>
                  <td>Onze wettelijke verplichting.</td>
                </tr>
                <tr>
                  <td>Bovengenoemde persoonsgegevens.</td>
                  <td>Om fraude of andere illegale of ongeoorloofde activiteiten te voorkomen, detecteren en bestrijden.</td>
                  <td>Onze wettelijke verplichting.</td>
                </tr>
                <tr>
                  <td>Bovengenoemde persoonsgegevens.</td>
                  <td>Om ons te verdedigen in gerechtelijke procedures.</td>
                  <td>Ons legitiem belang om jouw persoonsgegevens in deze procedures te gebruiken.</td>
                </tr>
                <tr>
                  <td>Bovengenoemde persoonsgegevens.</td>
                  <td>Om een derde te informeren in het kader van een mogelijke fusie met, overname van/door of splitsing door die derde, zelfs indien die derde buiten de EU is gevestigd.</td>
                  <td>Ons legitiem belang om zakelijke transacties te kunnen aangaan.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br/>

          <h1>4. Met wie delen wij jouw persoonsgegevens?</h1>

          <p>4.1. In principe delen wij jouw persoonsgegevens met niemand anders dan de personen die voor ons werken, evenals met de leveranciers die ons helpen bij de verwerking van jouw persoonsgegevens of jouw werkgever indien van toepassing. Iedereen die toegang heeft tot jouw persoonsgegevens zal altijd gebonden zijn door strikte wettelijke of contractuele verplichtingen om jouw persoonsgegevens veilig en vertrouwelijk te bewaren.</p>

          <p>4.2. Jouw persoonsgegevens kunnen door ons buiten de Europese Economische Ruimte (EER) worden verzonden in het kader van de hierboven vermelde doeleinden. Als er een doorgifte plaatsvindt, zullen wij voldoende waarborgen nemen om jouw persoonsgegevens bij overdracht te beschermen (bv. door het afsluiten van een overeenkomst op basis van door de Europese Commissie goedgekeurde standaardclausules inzake gegevensbescherming).</p>
          <br/>

          <h1>5. Hoe lang bewaren wij jouw persoonsgegevens?</h1>

          <p>5.1. Jouw persoonsgegevens worden slechts zolang verwerkt als nodig is om de hierboven beschreven doeleinden te bereiken of, wanneer wij jou om jouw toestemming hebben gevraagd, tot het moment dat je jouw toestemming intrekt. In dit artikel voorzien wij jou van de informatie die je nodig hebt om te beoordelen hoe lang wij jouw persoonsgegevens identificeerbaar houden.</p>

          <p>5.2. Als algemene regel geldt dat wij jouw persoonsgegevens zullen de-identificeren wanneer deze niet langer nodig zijn voor de hierboven beschreven doeleinden of wanneer de bewaartermijn, zoals in dit artikel 5 wordt uitgelegd, is verstreken. Wij kunnen jouw persoonsgegevens echter niet verwijderen als er een wettelijke of reglementaire verplichting of een gerechtelijk of administratief bevel bestaat dat ons verhindert deze te verwijderen.</p>

          <p>5.3. Alle persoonsgegevens die wij verzamelen via onze website bewaren wij zo lang als nodig om de in artikel 3.1 vermelde legitieme belangen te behartigen of tot op het moment dat je jouw toestemming intrekt. Technische informatie zoals onze serverlogbestanden bewaren wij tot 1 jaar na jouw bezoek aan onze website, waarna deze worden verwijderd of gede-identificeerd.</p>

          <p>5.4. Alle persoonsgegevens die wij in het kader van onze dienstverlening verzamelen, al dan niet via onze mobiele app, bewaren wij zo lang als nodig om de overeenkomst met jou uit te voeren of om de in artikel 3.3 vermelde legitieme belangen te behartigen. Jouw gegevens in verband met het beheer van jouw account en in het kader van onze dienstverlening bewaren wij zolang je gebruik maakt van onze diensten. Technische informatie in verband met jouw gebruik van onze mobiele app bewaren wij niet langer dan 5 jaren na jouw laatste gebruik van onze app, waarna deze wordt verwijderd of gede-identificeerd.</p>

          <p>5.5. Alle persoonsgegevens die wij verzamelen in verband met onze evenementen bewaren wij zo lang als nodig om de overeenkomst met jou uit te voeren, de in artikel 3.4 vermelde legitieme belangen te behartigen of tot op het moment dat je jouw toestemming intrekt. Als jouw foto niet werd gepubliceerd, bewaren wij jouw foto niet langer dan 2 jaren na het betreffende evenement. Als je je wenst te verzetten tegen een gepubliceerde foto van jou tijdens een evenement, geef ons dan een seintje (zie artikel 9).</p>

          <p>5.6.  Alle persoonsgegevens die wij via onze interacties met jou verzamelen via sociale media, telefoon, email of andere digitale communicatiekanalen bewaren wij zo lang als nodig om met jou te communiceren, maar ook om een historisch archief van onze communicatie te kunnen bijhouden. Dit stelt ons in staat om terug te keren naar eerdere communicatie als je bij ons terugkomt met nieuwe vragen, verzoeken, opmerkingen of andere input.</p>
          <br/>

          <h1>6. Hoe beveiligen wij jouw persoonsgegevens?</h1>

          <p>6.1. De veiligheid en vertrouwelijkheid van de persoonsgegevens die wij verwerken is zeer belangrijk voor ons. Daarom hebben wij maatregelen genomen om ervoor te zorgen dat alle verwerkte persoonsgegevens veilig worden bewaard. Deze maatregelen omvatten onder meer technische en organisatorische maatregelen om onze infrastructuur, systemen, toepassingen en processen te beveiligen. We hebben ook andere maatregelen genomen, zoals het nemen van interne beleidsmaatregelen, het beperken van de verwerking tot de persoonsgegevens die nodig zijn voor het bereiken van de doeleinden, het minimaliseren van de verwerking van persoonsgegevens, het indien mogelijk pseudonimiseren van persoonsgegevens, het nemen van backups van persoonsgegevens en het periodiek evalueren van onze beveiligingsmaatregelen.</p>
          <br/>

          <h1>7. Jouw rechten in verband met jouw persoonsgegevens</h1>

          <p>7.1. Je hebt bepaalde rechten in verband met de verwerking van jouw persoonsgegevens: het recht van toegang, rectificatie, verwijdering en overdraagbaarheid van persoonsgegevens, alsmede het recht om bezwaar te maken tegen de verwerking van jouw persoonsgegevens of deze te beperken en om jouw toestemming in te trekken. Om een van jouw rechten uit te oefenen, kan je een schriftelijk verzoek indienen bij rose@movetohappiness.com met vermelding van het recht waarop jouw verzoek betrekking heeft. Als je nog steeds niet tevreden bent, heb je het recht om contact op te nemen met de bevoegde gegevensbeschermingsautoriteit, d.w.z. de Belgische Gegevensbeschermingsautoriteit (<a href="www.gegevensbeschermingsautoriteit.be" target="_blank">www.gegevensbeschermingsautoriteit.be</a>).</p>
          <br/>

          <h1>8. Wijzigingen van dit privacybeleid</h1>

          <p>8.1. Wij kunnen dit privacybeleid op eigen initiatief en op eender welk moment wijzigen. Indien materiële wijzigingen aan dit privacybeleid een invloed kunnen hebben op de verwerking van jouw persoonsgegevens, dan zullen wij deze wijzigingen aan jou communiceren op een manier waarop wij normaal met jou communiceren (bv. via e-mail of via een bericht op onze website of via onze mobiele app).</p>

          <p>8.2. Wij nodigen jou uit om de laatste versie van dit privacybeleid op onze website te bekijken. Ons privacybeleid vermeldt de datum waarop ons privacybeleid het laatst werd gewijzigd.</p>
          <br/>

          <h1>9. Heb je nog vragen?</h1>

          <p>9.1. Mocht je nog vragen hebben over de verwerking van jouw persoonsgegevens, aarzel dan niet om contact op te nemen met onze privacy manager. Je kunt contact opnemen met onze privacy manager via e-mail: <a href="mailto:rose@movetohappiness.com">rose@movetohappiness.com</a>.</p>

<!--          <div
              v-intersect="onIntersect"
              class="py-12"
          ></div>-->
         
<!--        </v-card>-->
      </v-container>
      
      
<!--      <v-container class="pa-0 mb-3">
        <v-btn
            tile
            depressed
            color="primary"
            block
            large
            :disabled="!isIntersecting"
            @click.prevent="navigate"
        >
          {{ $t('buttons.acceptAndNext') }}
        </v-btn>
      </v-container>-->
      
<!--    </div>-->
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import maxios from "@/services/mediligo-axios";

export default {
  i18n: i18n,
  name: "m2h-privacy",
  props: ['session-id'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      isIntersecting: false
    }
  },
  mounted() {
  },

  methods: {
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },

    async navigate(){
      const res = await maxios.post("/api/onboarding/privacy",{session: this.sessionId});
      if (!res.data.success) {
        window.location.href = "/error";
      } else {
        window.location.href = '/tos/'+this.sessionId;
      }
    }
    
  },
}
</script>

<style scoped>

td, th{
  padding: 1rem!important;
}

tr:hover{
  background: none!important;
}

</style>
